export default function Settings () {
  const date = () => {
    const dateFormat = () => {
      if (window.navigator.language.indexOf('fr') > -1) {
        return 'DD/MM/YYYY'
      }
      return 'YYYY-MM-DD'
    }

    const datetimeFormat = () => {
      if (window.navigator.language.indexOf('fr') > -1) {
        return 'DD/MM/YYYY HH:mm'
      }
      return 'YYYY-MM-DD HH:mm'
    }

    const hourFormat = () => {
      return 'HH:00'
    }

    const longtimeFormat = () => {
      return 'HH:mm:ss'
    }

    const longdatetimeFormat = () => {
      if (window.navigator.language.indexOf('fr') > -1) {
        return 'DD/MM/YYYY HH:mm:ss'
      }
      return 'YYYY-MM-DD HH:mm:ss'
    }

    const shorttimeFormat = () => {
      return 'HH:mm'
    }

    return {
      dateFormat: dateFormat(),
      datetimeFormat: datetimeFormat(),
      hourFormat: hourFormat(),
      longdatetimeFormat: longdatetimeFormat(),
      longtimeFormat: longtimeFormat(),
      shorttimeFormat: shorttimeFormat()
    }
  }

  const opengraph = () => {
    return 'c46f36bd-00ff-4744-8a29-e2e7a9b32468'
  }

  const server = () => {
    const http = () => {
      // return 'https://devagent.greenbureau.com/api'
      return 'https://zenchatbc.greenbureau.com/api'
    }

    const ws = () => {
      // return 'wss://devagent.greenbureau.com/asgi/agents'
      return 'wss://zenchatbc.greenbureau.com/asgi/agents'
    }

    return {
      http: http(),
      ws: ws()
    }
  }

  const sentry = () => {
    return 'http://2f509633e60642199c5a87c4a6cb3bc0:7e0bcec746444a69aa382a9649fa7f5c@sentry.greenbureau.fr/20'
  }

  return {
    date: date(),
    sentry: sentry(),
    server: server(),
    opengraph: opengraph(),
    title: 'Banque Casino'
  }
}
